import { render, staticRenderFns } from "./AddBien.vue?vue&type=template&id=0528c3df&"
import script from "./AddBien.vue?vue&type=script&lang=js&"
export * from "./AddBien.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports